module.exports = __webpack_public_path__ + "static/media/3. Integrate with Jira.c23f6e1d.svg";